export type AudioPrefs = {
  bgmMuted: boolean;
  sfxMuted: boolean;
  vibrateMuted: boolean;
};

const KEY = {
  bgm: "gaoya.bgmMuted",
  sfx: "gaoya.sfxMuted",
  vibrate: "gaoya.vibrateMuted",
} as const;

let prefs: AudioPrefs = { bgmMuted: false, sfxMuted: false, vibrateMuted: false };

export function getAudioPrefs(): AudioPrefs {
  return prefs;
}

export function setAudioPrefs(next: AudioPrefs): void {
  prefs = { ...next };
}

export function loadAudioPrefs(getStorage: (key: string) => string | null): AudioPrefs {
  prefs = {
    bgmMuted: getStorage(KEY.bgm) === "1",
    sfxMuted: getStorage(KEY.sfx) === "1",
    vibrateMuted: getStorage(KEY.vibrate) === "1",
  };
  return prefs;
}

export function persistAudioPrefs(setStorage: (key: string, value: string) => void, next: AudioPrefs): void {
  prefs = { ...next };
  setStorage(KEY.bgm, next.bgmMuted ? "1" : "0");
  setStorage(KEY.sfx, next.sfxMuted ? "1" : "0");
  setStorage(KEY.vibrate, next.vibrateMuted ? "1" : "0");
}
